import { ref, watch } from "vue";
import {
  createRouter,
  createWebHistory,
  createWebHashHistory, // hash 模式，不用 pushState
  type Router,
  type RouteRecordRaw,
  type RouteRecordNormalized,
  type RouteLocationNormalized,
  type NavigationGuardNext,
  type RouteLocationRaw,
  RouteLocationNormalizedLoaded,
  NavigationFailure,
  useRoute,
  useRouter,
  RouterHistory
} from "vue-router";
export {
  RouterLink,
  RouterView,
  useRouter,
  useRoute,
  type Router
} from "vue-router";

// ****** for <yz-xg /> Xg.ce.vue WebComponent ******
import ViewDocument from "../components/view/ViewDocument.vue";
import Lot from "../components/xg/Lot.vue";
import Park from "../components/xg/Park.vue";
import Result from "../components/xg/Result.vue";
import Unlocking from "../components/xg/Unlocking.vue";
import LoginInPhone from "../components/xg/LoginInPhone.vue";
import ListDemo from "../components/xg/ListDemo.vue";

// ****** for <App /> App.vue ******
import Index from "../pages/Index.vue";
import ShapeShowCase from "../pages/ShapeShowCase.vue";
import ComponentShowCase from "../pages/ComponentShowCase.vue";
import RxMarbles from "../pages/RxMarbles.vue";
import { createFromEventPattern, useFeRoute } from "@zyzgroup/core-web";

const feRoute = useFeRoute({ nameInState: "current", alreadyPushState: true });

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/lot",
      name: "lot",
      component: Lot,
      props: (route) => ({ lottag: route.query.n || route.query.lottag })
    },
    {
      path: "/park",
      name: "park",
      component: Park
    },
    {
      path: "/result",
      name: "result",
      component: Result
    },
    {
      path: "/unlocking",
      name: "unlocking",
      component: Unlocking
    },
    {
      path: "/login",
      name: "login",
      component: LoginInPhone
    },
    {
      path: "/view-document/:title/:src",
      name: "view-document",
      component: ViewDocument
    },
    {
      path: "/list",
      name: "list",
      component: ListDemo
    },

    // ****** for <yz-xg /> Xg.ce.vue WebComponent ******
    // {
    //   path: "/",
    //   name: "xg",
    //   component: Lot
    //   // redirect: "/lot"
    // }

    // ****** for <App /> App.vue ******
    {
      path: "/",
      name: "index",
      component: Index
    },
    {
      path: "/shape",
      name: "shape",
      component: ShapeShowCase
    },
    {
      path: "/cs",
      name: "cs",
      component: ComponentShowCase
    },
    {
      path: "/rx/:operator?",
      name: "rx",
      component: RxMarbles
    }
  ],
  // [
  //   {
  //     path: "/",
  //     path: "/demo/:demoid",

  //     name: "home",

  //     component: HomeView,
  //     // router level code-splitting
  //     // this generates a separate chunk (About.[hash].js) for this router
  //     // which is lazy-loaded when the router is visited.
  //     component: () => import("../views/AboutView.vue"),

  //     meta: {},

  //     params: {
  //      title: "收费标准",
  //      src: encodeURIComponent(url)
  //     },
  //     query: { n: 739 }

  //     // error :  https://github.com/vuejs/router/blob/main/packages/router/CHANGELOG.md#414-2022-08-22
  //     props: true, // 把 route.params 当作 props
  //     props: { foo: 'bar' }, // 固定 props
  //     props: (route) => ({ id: route.query.id }) // 自定义 props

  //     children: [
  //       { path: "", name: "default", redirect: "/demo/sub1" },
  //       {
  //         path: "sub1",
  //         name: "sub1",
  //         component: () => import("@/src/views/sub1.vue")
  //       }
  //     ]
  //   },
  //   {
  //     path: "/:pathMatch(.*)*",
  //     name: "404",
  //     component: Page404
  //   }
  // ],
  scrollBehavior: (to, from, savedPosition) => {
    // 这个功能只在支持 history.pushState 的浏览器中可用
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  }
});

export default router;

// 路由导航守卫
router.beforeEach(
  (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    // console.log(to, from);
    // to 的有些对象值无法克隆，不能传给 window.history.pushState : Unexpected error when starting the router: DataCloneError: Failed to execute 'pushState' on 'History'
    feRoute.navigate(to.fullPath, {
      name: to.name,
      path: to.path,
      fullPath: to.fullPath,
      params: to.params,
      query: to.query
    });
    next();
  }
);
// 路由导航守卫
router.afterEach(
  (
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    failure?: NavigationFailure | void
  ) => {}
);

// 监听路由变更
export const routeChange$ = createFromEventPattern({
  register: (handler) => {
    router.afterEach(
      (
        to: RouteLocationNormalized,
        from: RouteLocationNormalizedLoaded,
        failure?: NavigationFailure | void
      ) => {
        // console.log(
        //   `路由从 oldPath=${from.fullPath} 变更为 newPath=${to.fullPath}`
        // );
        handler(
          getCurrentRouteDetail(to),
          getCurrentRouteDetail(from),
          feRoute.route,
          feRoute.history
        );
      }
    );
  },
  share: true
});

// 监听页面显示
export const pageShow$ = (routeName: string) =>
  createFromEventPattern({
    register: (handler) => {
      const route = useRoute();
      watch(
        () => route.name,
        (newName, oldName) => {
          // console.log(`路由从 ${oldName} 变更为 ${newName}`);
          if (routeName == newName) {
            handler();
          }
        },
        {
          immediate: true
        }
      );
    },
    share: false
  });

// 监听页面隐藏
export const pageHide$ = (routeName: string) =>
  createFromEventPattern({
    register: (handler) => {
      const route = useRoute();
      watch(
        () => route.name,
        (newName, oldName) => {
          // console.log(`路由从 ${oldName} 变更为 ${newName}`);
          if (routeName == oldName) {
            handler();
          }
        },
        {
          immediate: true
        }
      );
    },
    share: false
  });

// <RouterView v-slot="{ Component, route }"></RouterView>
// <RouterLink to="/">Home</RouterLink>
// <RouterLink to="/about">About</RouterLink>

// [Vue warn]: inject() can only be used inside setup() or functional components.
// http://localhost:5173/#/view-document/params1/params2/?test1=1
// const route = useRoute();
// route.params; // { params1, params2 }
// route.query; // { test1: 1 }
// const router: Router = useRouter();
// router.push("/wc");
// router.go(-1);

export function getCurrentRouteDetail(route = useRouter().currentRoute.value) {
  // 找到当前路由的配置
  const foundRoute = getRoutes().find((r) => r.name === route.name);
  const propsConfig = foundRoute?.props?.default;
  let props = {};
  if (propsConfig === true) {
    props = route.params;
  } else if (typeof propsConfig === "function") {
    props = propsConfig(route);
  } else if (typeof propsConfig === "object") {
    props = propsConfig;
  }
  return {
    ...route,
    params: route.params,
    query: route.query,
    props: { ...props, ...route.params, ...route.query },
    component: foundRoute?.components?.default
  };
}

export async function push(location: RouteLocationRaw) {
  const router: Router = useRouter();
  await router.push(location);
}
export async function to(path: string) {
  await push({ path });
}
export function back() {
  const router: Router = useRouter();
  router.back();
}

// 所有定义的 routes
export function getRoutes(): RouteRecordNormalized[] {
  const router: Router = useRouter();
  return router.getRoutes();
}

export function hasRoute(name: string): boolean {
  const router: Router = useRouter();
  return router.hasRoute(name);
}

// 动态注册路由
export function addRoute(route: RouteRecordRaw): () => void {
  const router: Router = useRouter();
  return router.addRoute(route);
}
export function addSubRoute(
  parentName: string,
  route: RouteRecordRaw
): () => void {
  const router: Router = useRouter();
  return router.addRoute(parentName, route);
}
// const remove = addSubRoute("demo", {
//   path: "sub2",
//   name: "sub2",
//   component: () => import("@/src/views/sub2.vue")
// });
// remove();

// 动态删除路由
export function removeRoute(name: string) {
  const router: Router = useRouter();
  router.removeRoute(name);
}
